import { StyleSheet } from "react-native"
import { baseColors, baseFontFamily, basePadding } from "@Constants/baseStyles"
import { RFValue } from "react-native-responsive-fontsize"

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: baseColors.white
    },
    content: {
        marginTop: 20
    },
    header: {
        marginBottom: 25
    },
    title: {
        color: baseColors.green.primary,
        marginBottom: 12
    },
    title: {
        color: baseColors.green.primary,
        marginBottom: 12
    },
    missionLabel: {
        color: baseColors.black,
        marginBottom: 20
    },
    item: {
        marginBottom: 18
    }
})

export default styles
